import { useState, useEffect } from "react"
import { useGQL } from "./useGQL.js"

export const useGetProductData = (productId) => {
	const [productData, setProductData] = useState(null)
	const gqlQuery = useGQL()

	const fetchProductData = async () => {
		const res = await gqlQuery(
			`
			query productById($productId: ID!) {
				product(id: $productId) {
					title
					images(first: 1) {
						nodes {
							url
						}
					}
				}
			}
		`,
			{ productId },
		).catch((err) => {
			console.error("useGetProductData gql error", err)
			return null
		})

		const title = res?.data?.product?.title || null
		const image = res?.data?.product?.images?.nodes?.[0]?.url || null

		if (title || image) {
			localStorage.setItem(
				`productData_${productId}`,
				JSON.stringify({ title, image, dateCached: new Date() }),
			)
		}

		setProductData({ title, image })
	}

	const fetchCachedProductData = () => {
		const cachedProductDataString = localStorage.getItem(
			`productData_${productId}`,
		)
		if (!cachedProductDataString) return null

		const cachedProductData = JSON.parse(cachedProductDataString)
		if (!cachedProductData?.dateCached) return null

		const oneMinuteAgo = new Date(new Date().getTime() - 1000 * 60)
		const cachedProductDataIsStale =
			new Date(cachedProductData.dateCached) < oneMinuteAgo

		if (cachedProductDataIsStale) return null

		return cachedProductData
	}

	useEffect(() => {
		try {
			const cachedProductData = fetchCachedProductData()

			if (cachedProductData) {
				setProductData(cachedProductData)
			} else {
				fetchProductData()
			}
		} catch (error) {
			console.error(error)
		}
	}, [productId])

	return {
		title: productData?.title || null,
		image: productData?.image || null,
	}
}
